//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class UserAccountDetailedStatusModel extends ModelBase {
      static readonly $typeName = 'UserAccountDetailedStatusModel';
      public createdBy: string;
      public failedLoginCount: number;
      public isAccountClosed: boolean;
      public isLoginAllowed: boolean;
      public lastLoginTime: Date;
      public lastUpdateBy: string;
      public passwordLastResetBy: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/customer/models/UserAccountDetailedStatusModel.ts